<template>
  <v-dialog v-model="openCapture" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
        <v-toolbar-title>{{ generateTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn :disabled="!img" dark text @click="saveFotoEmit">
            Guardar
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-list
          three-line
          subheader
      >
        <v-subheader>{{ generateSubtitle }} <v-icon class="mdi-48px">{{getSubtitleIcon}}</v-icon></v-subheader>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-subtitle>
              <v-file-input
                  v-model="imgCapture"
                  chips
                  :rules="[rules.required]"
                  prepend-icon="mdi-camera"
                  @change="imgTransform"

              ></v-file-input>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-subheader class="error--text" v-if="error">{{ error }}</v-subheader>
      </v-list>
      <v-divider></v-divider>
      <v-list v-show="img" three-line subheader>
        <v-subheader>Visualizacion</v-subheader>
        <v-col cols="12">
          <v-card elevation="10" shaped>
            <v-img
                :src="img"
                aspect-ratio="1.7"
                max-height="300"
                class="grey darken-4"
            ></v-img>
          </v-card>
        </v-col>


      </v-list>

    </v-card>
  </v-dialog>
</template>
<script>
import store from "@/store"
export default {
  name: 'capture-foto',
  props: {
  },
  data(){
    return {
      openCapture: false,
      imgCapture: null,
      img: null,
      error: '',
      rules: {required: value => !!value || 'Campo requerido.'},
      title: false
    }
  },
  computed:{
    generateTitle(){
      return this.title ? 'Documentación de la entrega' : 'Fotografía del sitio visitado.'
    },
    generateSubtitle(){
      return this.title ? 'Tome la foto en vertical' : 'Tome la foto en horizontal'
    },
    getSubtitleIcon() {
      return this.title ? 'mdi-crop-portrait' : 'mdi-crop-landscape'      
    }
  },
  methods: {
    imgTransform() {
      this.error = ''
      if (this.imgCapture) {
        if (!(/\.(jpg|png)$/i).test(this.imgCapture.name)) {
          this.error = 'No corresponde a una imagen'
          return
        }
        this.img = URL.createObjectURL(this.imgCapture)

      } else {
        this.img = null
      }
    },
    openDialog(click){
      this.openCapture = true
      if (click !== "clickEnNo") this.title = true

    },
    async saveFotoEmit(){
      store.commit('choferes/uploadFile', this.imgCapture)
      this.$emit('guardar')
      this.closeDialog()
    },
    closeDialog(){
      this.title = false
      this.openCapture = false
    }
  }
}
</script>
